















































































import { defineComponent, ref, computed } from '@vue/composition-api';
import GetAcceptLogo from '@getaccept/lib-ui/src/assets/img/getaccept-logo-small.svg';
import { useDebounceFn } from '@vueuse/core';
import { useReportEmail } from '../composables/report-email.composable';
import { UnsubscribeReason } from '../enums/unsubscribe-reason';

export default defineComponent({
  components: {
    GetAcceptLogo,
  },
  props: {
    isDsr: {
      type: Boolean,
    },
  },
  setup(props) {
    const reason = ref(null);
    const feedback = ref('');

    const handleReportSpam = () => {
      if (props.isDsr) {
        reportDsr(reasonObj.value);
      } else {
        report(reasonObj.value);
      }
    };

    const reasonObj = computed(() =>
      reason.value ? { type: reason.value, text: feedback.value } : undefined
    );

    const debounceFeedback = useDebounceFn((value: string) => {
      feedback.value = value;
    }, 500);

    const showFeedback = computed(() => reason.value === UnsubscribeReason.Other);

    const { loading, reported, report, reportDsr } = useReportEmail();

    return {
      handleReportSpam,
      loading,
      reported,
      reason,
      UnsubscribeReason,
      showFeedback,
      feedback,
      debounceFeedback,
    };
  },
});
